
define(
	'Code25.CaterpartsGlobal.AdvSearch.View'
	, [
		"Handlebars", "Utils", "Code25.advsearch.tpl", "Tools", 'js.cookie', "Facets.Model", "AjaxRequestsKiller", "Code25.CaterpartsGlobal.CSV.Model"
	]
	, function (
		Handlebars, Utils, Code25_advsearch_tpl, Tools, Cookies, FacetsModel, AjaxRequestsKiller, CSVModel
	) {
		'use strict';

		var LiveOrderModel = require('LiveOrder.Model'); //Depreciated

		var advsearchSettings = {
			selectedBrand: "",
			productCats: [],
			productModels: [],
			index: 0
		}

		return Backbone.View.extend({
			placeholder: "1,Q423055\r\n23,Q399127\r\n\r\nOR\r\n\r\n1 Q423055\r\n23 Q399127",
			testdata: "2,Q410477\r\n3,Q340442\r\n1,01-515269-6",

			template: Code25_advsearch_tpl,
			initialize: function (options) {

			},
			events: {
				'change [data-action="brand"]': 'brandChange',
				'click [data-action="search1"]': 'search1',
				'click [data-action="search2"]': 'search2',
				'click [data-action="search3"]': 'search3',
				'click [data-action="selected-tab"]': 'selectedTab',
				'click [data-action="addparts"]': 'uploadCSV',
			}, addMatch: function (match) {
				if (sessionStorage) {
					var matched = {};
					try {
						matched = JSON.parse(sessionStorage.getItem("matched") || "{}");
					} catch (err) { }
					matched[match] = true;
					sessionStorage.setItem("matched", JSON.stringify(matched));
				} else {
					window.matched = window.matched || {};
					window.matched[match] = true;
				}
			}, uploadCSV: function (e) {
				console.log("upload");
				var csv = $("textarea").val();
				if (!csv) {
					Tools.showErrorInModal(SC.Application, Utils.translate(Utils.translate("Multi Sku Order")), Utils.translate("Enter a list of items."));
				} else {
					console.log(csv);

					var model = new CSVModel();
					var self = this;

					model.fetch({
						data: {
							csv: csv
						},
						success: function (res) {
							// console.log("res", res);
							if (model.get("ok")) {
								var lines = model.get("lines");
								// console.log("uploaded", items.length);

								self.successMessage(lines);
							} else {
								self.successMessage([], model.get("error") || "Unknown error.");
							}


						},
						error: function (err, err2) {
							if (err2) {
								err = err2;
							}
							var responseJSON = err && err.responseJSON;
							//console.log(responseJSON);
							var order = LiveOrderModel.getInstance();
							order.fetch();

							if (responseJSON && responseJSON.errorStatusCode == "500") {
								if (responseJSON.errorMessage && (responseJSON.errorMessage.indexOf("internal error") > -1 || responseJSON.errorMessage.indexOf("Gateway") > -1 || responseJSON.errorMessage.indexOf("proxy") > -1)) {
									self.successMessage(null, "The CSV upload did not finish. The connection to the server failed or took too long. Check your internet connection, try uploading a shorter files, wait and try again.");
								} else {
									self.successMessage(null, responseJSON.errorMessage);
								}
							} else {
								self.successMessage(null, (err || "").toString());
							}
							console.log("err", err);
						}
					});

				}
			}, successMessage: function (lines, error) {

				if (error) {
					Tools.showErrorInModal(SC.Application, Utils.translate(Utils.translate("Multi Sku Order")), Utils.translate(error));
					return;
				}
				var someFailed = false, success = 0, failed = 0, hErrors = {};
				for (var i = 0; i < lines.length; i++) {

					if (lines[i].failed) {
						someFailed = true;
						failed++;
						hErrors[lines[i].error] = true;
					} else if (!lines[i].ok) {
						someFailed = true;
						failed++;
						hErrors[lines[i].error] = "Unknown error.";
					} else {
						success += lines[i].quantity;
					}
					
					if(lines[i].itemid!=lines[i].name&&lines[i].name){
						this.addMatch(lines[i].name.toLowerCase());
					}
				}

				var body = "", j = 0, parts;

				body += "<p>" + Utils.translate('$(0) items added to the cart.', success) + "</p><br />";

				if (someFailed) {
					body += "<p>" + Utils.translate('$(0) skus could not be added to the cart. See below for details. Please <a href="/contact-us">contact us</a> with any questions.', failed) + "</p><br />";
				}
				for (var err in hErrors) {


					body += "<h5><b>" + Utils.translate(err) + "</b></h5>";



					body += "<table style=\"width:100%;\"><tr>";
					j = 0;
					for (var i = 0; i < lines.length; i++) {

						if ((lines[i].failed)) {
							//(i + 1).toString() + ": " +
							body += "<td>" + lines[i].name + " x" + lines[i].quantity + "</td>";
							j++;
							if (j % 3 == 0 && i != lines.length) {
								body += "</tr><tr>"
							}

						}
					}

					body += "</tr></table><br />";
				}
				var order = LiveOrderModel.getInstance();
				order.fetch();

				Tools.showSuccessInModal(SC.Application, Utils.translate("Multi Sku Order"), body);

			}
			,
			selectedTab: function (e) {
				var id = $(e.target).attr("data-id");
				if (id) {
					advsearchSettings.index = parseInt(id);
				}
			}
			,
			brandChange: function (e) {
				// console.log(e);
				var self = this;
				var brand = $(e.target).val();
				if (brand == "-") {
					brand = "";
				}
				advsearchSettings.selectedBrand = brand;
				var model = new FacetsModel({ items: [], facets: [], total: 0 });
				advsearchSettings.productCats = [];
				advsearchSettings.productModels = [];
				self.render();
				model.fetch({
					data: { manufacturer: brand }, //translator.getApiParams()
					killerId: AjaxRequestsKiller.getKillerId()
				}).done(function (res) {
					// console.log(res);
					var facets = res.facets;
					if (facets && facets.length > 0) {
						for (var i = 0; i < facets.length; i++) {
							if (facets[i].id == "custitem_equipment_type") {
								advsearchSettings.productCats = [{ url: "all", label: "All" }].concat(facets[i].values);
							} else if (facets[i].id == "custitem_c25_search_model") {
								advsearchSettings.productModels = [{ url: "all", label: "All" }].concat(facets[i].values);
							}
						}
					}
					self.render();
				});
			}, formatBrand: function (brand) {
				brand = brand.split("-").join("~");
				brand = brand.split("/").join("-SLASH-");
				brand = brand.split(" ").join("-");
				brand = brand.split("Classeq").join("Classeque");
				brand = brand.split("E.G.O.").join("E.-G.-O.");
				brand = brand.split("Hoonved--SLASH--Blue-Seal").join("Hoonved--SLASH--Blue-Seal-warewashing");

				return brand;
			}
			,
			search1: function (e) {
				var cat = this.$el.find("#cats").val();
				var brand = advsearchSettings.selectedBrand;
				if (brand) {
					brand = this.formatBrand(brand);

					if (cat && cat != "-" && cat != "all") {
						Backbone.history.navigate('/manufacturer/' + brand + "/equipmenttype/" + cat, { trigger: true });
					} else {
						Backbone.history.navigate('/manufacturer/' + brand, { trigger: true });
					}
				}
			}, search2: function (e) {
				var model = this.$el.find("#models").val();
				var brand = advsearchSettings.selectedBrand;
				if (brand) {
					brand = this.formatBrand(brand);
					if (model && model != "-" && model != "all") {
						Backbone.history.navigate('/manufacturer/' + brand + "/model/" + model, { trigger: true });
					} else {
						Backbone.history.navigate('/manufacturer/' + brand, { trigger: true });
					}
				}
			}, search3: function (e) {
				var model = this.$el.find("#models").val();
				var brand = advsearchSettings.selectedBrand;
				if (brand) {
					brand = this.formatBrand(brand);
					if (model && model != "-" && model != "all") {
						Backbone.history.navigate('/Parts-Books/manufacturer/' + brand + "/model/" + model, { trigger: true });
					} else {
						Backbone.history.navigate('/Parts-Books/manufacturer/' + brand, { trigger: true });
					}
				}
			},
			getContext: function getContext() {

				//https://caterparts.code25.com/api/cacheable/items?c=1120086&country=GB&currency=GBP&fieldset=search&include=facets&language=en&limit=24&manufacturer=Maidaid--SLASH--Halcyon&n=5&offset=0&pricelevel=2&sort=custitem_c25_searchpriority%3Adesc&use_pcv=F
				var categories = SC.CATEGORIES, subcats;
				//console.log("categories", categories);
				var brands = [], hcats = {};//{name:"Spares"}
				for (var i = 0; i < categories.length; i++) {
					subcats = categories[i].categories;
					if (subcats.length > 0) {

						for (var j = 0; j < subcats.length; j++) {
							if (subcats[j].name != "Ancillaries" && subcats[j].name != "Ancillaries / Tools" && subcats[j].name != "Featured Products" && subcats[j].name != "Special Offers") {
								for (var k = 0; k < subcats[j].categories.length; k++) {
									if (!hcats[subcats[j].categories[k].name] && subcats[j].categories[k].name.indexOf("(") == -1) {
										brands.push({ name: subcats[j].categories[k].name });
										hcats[subcats[j].categories[k].name] = true;
									}
								}
							}
						}
					}
				}
				brands.sort(function (A, B) {
					return A.name.localeCompare(B.name);
				})
				advsearchSettings.productCats.sort(function (A, B) {
					if (B.url == "all") {
						return 1;
					}
					return A.label.localeCompare(B.label);
				})
				advsearchSettings.productModels.sort(function (A, B) {

					if (B.url == "all") {
						return 1;
					}

					return A.label.localeCompare(B.label);
				})
				return {
					details: [
						{
							name: "Shop by Product Category",
							brands: brands,
							productCats: advsearchSettings.productCats,
							selectedBrand: advsearchSettings.selectedBrand,
							hasCats: advsearchSettings.productCats.length > 0,
							hasBrand: !!advsearchSettings.selectedBrand,
							selected: advsearchSettings.index == 0
						},
						{
							name: "Shop by Model",
							brands: brands,
							productModels: advsearchSettings.productModels,
							selectedBrand: advsearchSettings.selectedBrand,
							hasModels: advsearchSettings.productModels.length > 0,
							hasBrand: !!advsearchSettings.selectedBrand,
							selected: advsearchSettings.index == 1
						},
						{
							name: "Parts Books by Model",
							brands: brands,
							productModels: advsearchSettings.productModels,
							selectedBrand: advsearchSettings.selectedBrand,
							hasModels: advsearchSettings.productModels.length > 0,
							hasBrand: !!advsearchSettings.selectedBrand,
							selected: advsearchSettings.index == 2
						},
						{
							name: "Multi Sku Order",
							selected: advsearchSettings.index == 3,
							placeholder: this.placeholder,
							test: document.location.href.indexOf("-local") > -1 ? this.testdata : ""
						}
					]
				};
			}
		});

	});



